import styles from './ImmigrationDocuments.module.scss';
import { AccordionSize, AccordionVariant } from '@ds/elements/Accordion/Accordion.types';
import { Accordion } from '@ds/elements/Accordion/Accordion';
import { getFormattedDate, UserDateFormat } from 'src/utils/formatters/formatDate';
import { useGetImmigrationDocDetails } from 'src/shared/queries/useGetImmigrationDocDetails';
import { FallbackPlaceholderText } from 'src/utils/constants/common';
import ImmigrationDocDetail from './ImmigrationDocDetail';
import { evaluateImmigrationDocumentStatus, ImmigrationDocumentStatus } from '../ImmigrationStatus.service';
import ActiveStatus from '@icons/checkmark-circle.svg';
import InactiveStatus from '@icons/dash-circle-2.svg';
import PendingStatus from '@icons/elipsis-circle.svg';

const ImmigrationDocuments = (details: {
  beneId: number | undefined;
  dependentId: number | undefined;
  showActiveOnly: boolean;
}) => {
  const { data: docDetails } = useGetImmigrationDocDetails(
    details?.dependentId ? undefined : details?.beneId,
    details?.dependentId,
    true
  );

  const getImmigrationDocumentStatus = (doc: any) => {
    const status = evaluateImmigrationDocumentStatus(doc);
    switch (status) {
      case ImmigrationDocumentStatus.Active:
        return ActiveStatus;
      case ImmigrationDocumentStatus.Inactive:
        return InactiveStatus;
      case ImmigrationDocumentStatus.Pending:
        return PendingStatus;
    }
  };

  return (
    <div className={styles['immigration-status-immigration-documents']}>
      {docDetails?.map((docDetail, outerIndex) => (
        <div key={outerIndex}>
          <h3 className="my-2">{docDetail.countryName}</h3>

          <Accordion
            activeIndex={null}
            className={styles['immigration-documents-accordion']}
            variant={AccordionVariant.Transparent}
            size={AccordionSize.Large}
            highlightActive={false}
            multiple={true}
            tabs={docDetail.immigrationDocuments
              .filter(
                (doc) =>
                  !details.showActiveOnly ||
                  evaluateImmigrationDocumentStatus(doc) != ImmigrationDocumentStatus.Inactive
              )
              .map((doc) => ({
                header: (
                  <div className={`flex flex-wrap ${styles['immigration-documents-accordion__header']} mt-2 mb-2`}>
                    <div className="flex-shrink-0 p-4">
                      <img src={getImmigrationDocumentStatus(doc)} />
                    </div>
                    <div className={`flex flex-col sm:w-auto xl:flex-row ${styles['header-cols']}`}>
                      <div className={`py-2 px-4 ${styles['header-col']}`}>
                        <label>Classification:</label>
                        <p>{doc.classfication || FallbackPlaceholderText.TripleDash}</p>
                      </div>
                      <div className={`py-2 px-4 ${styles['header-col']}`}>
                        <label>Document:</label>
                        <p>{doc.immigrationDocType || FallbackPlaceholderText.TripleDash}</p>
                      </div>
                      <div className={`py-2 px-4 ${styles['header-col']}`}>
                        <label>Expiration Date:</label>
                        <p>
                          {doc.expirationDate == null
                            ? FallbackPlaceholderText.TripleDash
                            : getFormattedDate(doc.expirationDate as string, UserDateFormat.get())}
                        </p>
                      </div>
                    </div>
                  </div>
                ),
                body: (
                  <div
                    className={`flex flex-wrap flex-col md:flex-row md:p-5 ${styles['immigration-documents-accordion__body']}`}
                  >
                    <ImmigrationDocDetail docId={doc.immigrationDocId} beneId={details.beneId} />
                  </div>
                ),
              }))}
          />
        </div>
      ))}
    </div>
  );
};

export default ImmigrationDocuments;
